import React from 'react';

import { Badge } from 'shadcn/components/ui/Badge';

/**
 * Returns the Badge className for a substitution rule enabled status.
 *
 * @param {boolean} isEnabled - Whether the rule is enabled for the facility.
 * @returns {string} Tailwind classes for the status badge.
 */
export function getEnabledStatusBadgeClassName(isEnabled) {
    if (isEnabled) {
        return 'bg-sky-600 text-white border-sky-700 hover:bg-sky-600 hover:text-white';
    }

    return 'bg-slate-200 text-slate-800 border-slate-300 hover:bg-slate-200 hover:text-slate-800';
}

/**
 * Renders the enabled/disabled status badge for a substitution rule row.
 *
 * @param {Object} props - Component props.
 * @param {boolean | null | undefined} props.isEnabled - Raw enabled value from the table row.
 * @returns {JSX.Element} Enabled status badge JSX.
 */
export function SubstitutionRuleEnabledStatusCell({ isEnabled }) {
    const enabled = isEnabled !== false;
    const label = enabled ? 'Enabled' : 'Disabled';

    return (
        <Badge variant="outline" className={getEnabledStatusBadgeClassName(enabled)}>
            {label}
        </Badge>
    );
}
